module.exports = "/_next/static/images/dfa051bd0b8fdea9726f96461e734d79-requirements-lg.jpg";